export const guessResultCharacterClass = [
    'gray-cell',
    'yellow-cell',
    'green-cell',
    'white-cell'
];